import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import type { FanguardApiContractsWatchlistWatchlistSummaryModel } from 'src/api/generated';

export const LISTS_URI = 'watchlists';

export const listsQueries = createQueryKeys(LISTS_URI, {
  all: null,
  list: () => ({
    queryKey: ['all'] as const,
    queryFn: async () => {
      const response = await get<FanguardApiContractsWatchlistWatchlistSummaryModel[]>({ uri: LISTS_URI });
      return response.data;
    },
  }),
  detail: (id: string) => ({
    queryKey: [id],
    queryFn: async () => {
      const response = await get<FanguardApiContractsWatchlistWatchlistSummaryModel>({
        uri: `${LISTS_URI}/${id}`,
      });
      return response;
    },
  }),
});
